import type { ProjectionPoint } from '@financego/core';

import { useI18n } from '../../i18n/useI18n';
import { formatMoney } from './dashboard-format';
import { buildPolyline } from './projection-chart-data';

interface ProjectionChartProps {
  readonly points: readonly ProjectionPoint[];
}

export function ProjectionChart({ points }: ProjectionChartProps) {
  const { locale, t } = useI18n();
  const path = buildPolyline(points, 600, 150);

  return (
    <div className="projection-chart">
      <svg
        aria-label={t('dashboard.chartLabel', {
          end: formatMoney(points.at(-1)?.balance ?? 0, locale),
          start: formatMoney(points[0]?.balance ?? 0, locale),
        })}
        preserveAspectRatio="none"
        role="img"
        viewBox="0 0 600 150"
      >
        <defs>
          <linearGradient id="projection-fill" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="var(--fg-accent)" stopOpacity="0.32" />
            <stop offset="100%" stopColor="var(--fg-accent)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d={`${path} L 600 150 L 0 150 Z`} fill="url(#projection-fill)" />
        <path className="projection-line" d={path} fill="none" />
      </svg>
    </div>
  );
}
